import React, { useState } from "react";
import { Box } from "@mui/material";

import { StyledWhiteContainer } from "features/metadesk/settings/common.styles";
import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import Percent from "components/Percent/Percent";
import { formatDate, formatTime } from "features/helpers/utils";
import { kolColors } from "features/configure/chartColors";
import { useIntl } from "react-intl";
// import useGetXChart from "./hooks/useGetXChart";
import useNavigateEntity from "hooks/useNavigateEntity";
import { StyledSkeleton } from "components/LoadingComponent/LoadingComponent.styles";
import DualYAxisChartContainer from "components/DualYAxisChart/DualYAxisChartContainer";
import { useTheme } from "@mui/material";
import { formatNumberWithSymbol } from "features/helpers/utils";
import { CustomLineChart } from "components/CustomCharts";
export default function XPerformanceChart() {
  const theme = useTheme();

  const [selectedYAxis, setSelectedYAxis] = useState([
    "mentionCount",
    "tokenPrice",
  ]);
  const [selectedKols, setSelectedKols] = useState([
    {
      _id: "1",
      name: "test1",
    },
  ]);
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const { entityName } = useNavigateEntity();
  const { formatMessage } = useIntl();

  const totals = [
    {
      label: formatMessage({
        id: "global.metrics.mentionCount",
      }),
      key: "mentionCount",
      tooltip: formatMessage({
        id: "global.metrics.mentionCount.tooltip",
      }),
    },
    {
      label: formatMessage({
        id: "global.metrics.impression",
      }),
      key: "impression",

      tooltip: formatMessage({ id: "global.metrics.impression.tooltip" }),
    },
    {
      label: formatMessage({
        id: "global.metrics.engagement",
      }),
      key: "engagement",

      tooltip: formatMessage({ id: "global.metrics.engagement.tooltip" }),
    },
  ];

  const mentionChartYAxisInfos = [
    {
      name: formatMessage({
        id: "global.filter.mention",
      }),
      key: "mentionCount",
    },
    {
      name: formatMessage({
        id: "global.filter.price",
      }),
      key: "tokenPrice",
    },
  ];

  const colors = kolColors.middle;
  // const { data, day, isLoading } = useGetXChart();

  // tmp mock data
  const data = {
    total: {
      mentionCount: {
        count: 77192,
        growth: "-",
      },
      impression: {
        count: 5390,
        growth: "-",
      },
      engagement: {
        count: 2828,
        growth: "-",
      },
    },
    mentionChartData: [
      {
        date: "2025-01-03",
        mentionCount: 51828,
        tokenPrice: 2539,
      },
      {
        date: "2025-01-04",
        mentionCount: 56497,
        tokenPrice: 3039,
      },
      {
        date: "2025-01-05",
        mentionCount: 61601,
        tokenPrice: 3587,
      },
      {
        date: "2025-01-06",
        mentionCount: 66542,
        tokenPrice: 4110,
      },
      {
        date: "2025-01-07",
        mentionCount: 70793,
        tokenPrice: 4616,
      },
      {
        date: "2025-01-08",
        mentionCount: 75469,
        tokenPrice: 5168,
      },
      {
        date: "2025-01-09",
        mentionCount: 77192,
        tokenPrice: 2828,
      },
    ],
    engagementChartData: [
      {
        date: "2025-01-03",
        kols: [
          {
            _id: "1",
            name: "test1",
            engagement: 100,
          },
          {
            _id: "2",
            name: "test2",
            engagement: 200,
          },
          {
            _id: "3",
            name: "test3",
            engagement: 300,
          },
          {
            _id: "4",
            name: "test4",
            engagement: 400,
          },
          {
            _id: "5",
            name: "test5",
            engagement: 500,
          },
          {
            _id: "6",
            name: "test6",
            engagement: 600,
          },
        ],
      },
      {
        date: "2025-01-04",
        kols: [
          {
            _id: "1",
            name: "test1",
            engagement: 100,
          },
          {
            _id: "2",
            name: "test2",
            engagement: 200,
          },
          {
            _id: "3",
            name: "test3",
            engagement: 300,
          },
          {
            _id: "4",
            name: "test4",
            engagement: 400,
          },
          {
            _id: "5",
            name: "test5",
            engagement: 500,
          },
          {
            _id: "6",
            name: "test6",
            engagement: 600,
          },
        ],
      },
      {
        date: "2025-01-05",
        kols: [
          {
            _id: "1",
            name: "test1",
            engagement: 100,
          },
          {
            _id: "2",
            name: "test2",
            engagement: 200,
          },
          {
            _id: "3",
            name: "test3",
            engagement: 300,
          },
          {
            _id: "4",
            name: "test4",
            engagement: 400,
          },
          {
            _id: "5",
            name: "test5",
            engagement: 500,
          },
          {
            _id: "6",
            name: "test6",
            engagement: 600,
          },
        ],
      },
      {
        date: "2025-01-06",
        kols: [
          {
            _id: "1",
            name: "test1",
            engagement: 100,
          },
          {
            _id: "2",
            name: "test2",
            engagement: 200,
          },
          {
            _id: "3",
            name: "test3",
            engagement: 300,
          },
          {
            _id: "4",
            name: "test4",
            engagement: 400,
          },
          {
            _id: "5",
            name: "test5",
            engagement: 500,
          },
          {
            _id: "6",
            name: "test6",
            engagement: 600,
          },
        ],
      },
      {
        date: "2025-01-07",
        kols: [
          {
            _id: "1",
            name: "test1",
            engagement: 100,
          },
          {
            _id: "2",
            name: "test2",
            engagement: 200,
          },
          {
            _id: "3",
            name: "test3",
            engagement: 300,
          },
          {
            _id: "4",
            name: "test4",
            engagement: 400,
          },
          {
            _id: "5",
            name: "test5",
            engagement: 500,
          },
          {
            _id: "6",
            name: "test6",
            engagement: 600,
          },
        ],
      },
      {
        date: "2025-01-08",
        kols: [
          {
            _id: "1",
            name: "test1",
            engagement: 100,
          },
          {
            _id: "2",
            name: "test2",
            engagement: 200,
          },
          {
            _id: "3",
            name: "test3",
            engagement: 300,
          },
          {
            _id: "4",
            name: "test4",
            engagement: 400,
          },
          {
            _id: "5",
            name: "test5",
            engagement: 500,
          },
          {
            _id: "6",
            name: "test6",
            engagement: 600,
          },
        ],
      },
      {
        date: "2025-01-09",
        kols: [
          {
            _id: "1",
            name: "test1",
            engagement: 100,
          },
          {
            _id: "2",
            name: "test2",
            engagement: 200,
          },
          {
            _id: "3",
            name: "test3",
            engagement: 300,
          },
          {
            _id: "4",
            name: "test4",
            engagement: 400,
          },
          {
            _id: "5",
            name: "test5",
            engagement: 500,
          },
          {
            _id: "6",
            name: "test6",
            engagement: 600,
          },
        ],
      },
    ],
  };
  const day = "1";
  const isLoading = false;

  const { mentionChartData, engagementChartData, total: totalData } = data;

  const xAxisData = engagementChartData.map((d) => {
    return formatDate(d.date, { month: true });
  }); // 去重後的日期

  const dualYAxisChartData = {
    xAxisData,
    yAxisData: {
      lineChartData: mentionChartData,
    },
  };

  const chartInfos = [
    {
      title: "global.chart.keywordMentionsPrice",
      tooltip: "global.chart.keywordMentionsPrice.tooltip",
      showYAxisDropdown: false,
      type: "line",
      hasData: mentionChartData?.length > 0,
    },
  ];

  const engagementChartDropdownOptions = engagementChartData[0]?.kols.map(
    (kol) => ({
      label: kol.name,
      value: kol._id,
    })
  );
  const engagementChartSeries = selectedKols.map((kol, index) => {
    const kolData = engagementChartData.map((d) => {
      const kolData = d.kols.find((k) => k._id === kol._id);
      return kolData?.engagement || 0;
    });
    return {
      name: kol.name,
      type: "line",
      data: kolData,
      symbolSize: 5,
      itemStyle: {
        color: colors[index],
        borderWidth: 1, // have bug
      },
    };
  });

  const calculateTotalEngagement = (kolId) => {
    const kolData = engagementChartData.map((d) => {
      const kolData = d.kols.find((k) => k._id === kolId);
      return kolData?.engagement || 0;
    });
    return formatNumberWithSymbol(kolData.reduce((acc, cur) => acc + cur, 0));
  };

  const renderTotalStats = () =>
    totals.map((total, index) => (
      <StyledWhiteContainer key={index} sx={{ marginBottom: "12px" }}>
        <Box
          height="52px"
          sx={{
            minWidth: "113px",
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          <Box className="item-flex" gap="4px">
            <Box fontSize={16} color="#777">
              {total.label}
            </Box>
            <IconTooltip
              content={total.tooltip}
              customColor={theme.customColors.purple[500]}
            />
          </Box>
          <Box className="item-flex" justifyContent="space-between" gap="10px">
            {isLoading ? (
              <StyledSkeleton
                animation="wave"
                sx={{ width: "80%", height: "24px", margin: "2px 0" }}
              />
            ) : (
              <>
                <Box fontSize={24} fontWeight={700} color="#555">
                  {totalData[total.key]?.count.toLocaleString()}
                </Box>
                {day && (
                  <Percent
                    data={
                      totalData[total.key]?.growth === "-"
                        ? "-"
                        : (totalData[total.key]?.growth * 100).toFixed(2)
                    }
                  />
                )}
              </>
            )}
          </Box>
        </Box>
      </StyledWhiteContainer>
    ));

  return (
    <Box>
      <Box sx={{ display: "flex", gap: "12px" }}>{renderTotalStats()}</Box>
      <StyledWhiteContainer sx={{ marginBottom: "12px", paddingBottom: 0 }}>
        <DualYAxisChartContainer
          data={dualYAxisChartData}
          yAxisInfos={mentionChartYAxisInfos}
          selectedYAxis={selectedYAxis}
          setSelectedYAxis={setSelectedYAxis}
          colors={colors.slice(0, -1)}
          chartInfos={chartInfos}
          isLoading={isLoading}
        />
      </StyledWhiteContainer>
      <StyledWhiteContainer sx={{ marginBottom: "12px", paddingBottom: 0 }}>
        {/* Engagement Chart */}
        <CustomLineChart
          chartTitleKey="global.chart.engagementTrends"
          isLoading={isLoading}
          selectedItems={selectedKols}
          customNodeInOption={
            <Box paddingLeft="16px" mb="8px">
              <Box
                color={(theme) => theme.customColors.grey[600]}
                sx={{ fontSize: "12px", fontWeight: 600 }}
              >
                {showAlertMessage ? (
                  <Box color={(theme) => theme.customColors.pink[600]}>
                    {formatMessage(
                      { id: "dropdown.select.reachOptionLimit" },
                      { limit: 5 }
                    )}
                  </Box>
                ) : (
                  <Box>
                    {formatMessage(
                      { id: "dropdown.select.optionLimit" },
                      {
                        limit: 5,
                        options: "Kols",
                        count: selectedKols.length,
                      }
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          }
          chartData={{
            xAxisData,
            yAxisData: engagementChartData,
            seriesData: engagementChartSeries,
          }}
          chartColors={colors}
          itemDropDownProps={{
            onChange: (event, newValue) => {
              if (setSelectedKols) {
                if (newValue.length > 5) {
                  setShowAlertMessage(true);
                } else if (newValue.length === 0) {
                  return;
                } else {
                  setShowAlertMessage(false);
                  setSelectedKols(
                    newValue.map((item) => ({
                      _id: item.value,
                      name: item.label,
                    }))
                  );
                }
              }
            },
            options: engagementChartDropdownOptions,
          }}
          totalStatsData={selectedKols.map((kol) =>
            calculateTotalEngagement(kol._id)
          )}
        />
      </StyledWhiteContainer>
    </Box>
  );
}
